import * as React from "react"
import { useDispatch, useSelector } from "react-redux"
import { IEntry } from "../../types/appDataTypes"
import { appActions, userInfoActions } from "../../actions"
import { addMessage } from "../MessageContainer"
import { ButtonBase } from "@material-ui/core"
import * as AppTypes from "AppTypes"
import api from "../../utils/api"

interface IEntrySummary {
    entry: IEntry
    entryIndex: number
    isInvalid?: boolean
}

const EntrySummary: React.FC<IEntrySummary> = props => {
    const dispatch = useDispatch()
    const { entry, entryIndex, isInvalid } = props

    const { pictureStore, appId, langPack } = useSelector((store: AppTypes.ReducerState) => ({
        appId: store.userInfo.appId,
        pictureStore: store.app.pictureStore,
        langPack: store.config.langPack
    }))

    const pictures = pictureStore[entry.entryId]

    const entryEditorHandler = (event: React.MouseEvent) => {
        event.stopPropagation()
        dispatch(appActions.gotoStep("EntryEditor", { entryIndex }))
    }
    const entryDeleteHandler = async (event: React.MouseEvent) => {
        event.stopPropagation()
        const decision = await addMessage({
            text: langPack["sureDelete"],
            buttons: { confirm: langPack["buttonConfirm"], cancel: langPack["buttonBack"] }
        })
        if (decision) {
            const response = await api.deleteEntry(appId, entry.entryId)
            if (response && response.status === 200) {
                dispatch(userInfoActions.deleteEntry(entry))
            }
        }
    }

    return (
        <div className={`dashboard__entries__summary dashboard__entries__summary--viewer entry-viewer ${isInvalid ? "warning" : ""}`} >
            <div className="entry-viewer__content">
                <h5>{langPack["artworkTitle"]}</h5>
                <p>{entry.title}</p>
                {isInvalid && <p className="app-warning">{langPack["pleaseComplete"]}</p>}
            </div>
            <div
                className="entry-viewer__thumbnail"
                onClick={entryEditorHandler}
            >
                <div
                    className="entry-viewer__picture"
                    style={pictures && pictures.p1
                        ? { backgroundImage: `url(${pictures.p1})` }
                        : {}
                    }
                ></div>
            </div>
            <div className="entry-viewer__actions">
                <ButtonBase
                    className={`entry-viewer__button entry-viewer__button--edit ${isInvalid ? "warning" : ""}`}
                    onClick={entryEditorHandler} >
                    {"EDIT"}
                </ButtonBase>
                <ButtonBase
                    className="entry-viewer__button entry-viewer__button--delete"
                    onClick={entryDeleteHandler}>
                    {"DELETE"}
                </ButtonBase>
            </div>
        </div>

    )
}

export default EntrySummary
